import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


function testimonialNoImageSlider() {
    const testimonialNoImageSliders = document.querySelectorAll('.testimonial-no-image-slider');

    if (testimonialNoImageSliders.length > 0) {
        testimonialNoImageSliders.forEach((testimonialNoImageSlider) => {

            function initializeSwiper() {
                let swiper = new Swiper(testimonialNoImageSlider, {
                    modules: [ Navigation, Pagination ],
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next.no-image',
                        prevEl: '.swiper-button-prev.no-image',
                    },
                    pagination: {
                        el: ".testimonial-swiper-pagination",
                        type: "custom",
                        renderCustom: function (swiper, current, total) {
                            return `<span class="text-red">${current}</span> / ${total}`;
                        },
                    }, 
                    slidesPerView: 1,
                    spaceBetween: 40,
                    speed: 1000,
                    centeredSlides: true,
                    breakpoints: {
                        576: {
                            slidesPerView: 1.2,
                        },
                    },
                });

                // Set the height of all slides to the height of the tallest slide
                setEqualHeight(testimonialNoImageSlider, swiper);
            }

            function setEqualHeight(container, swiper) {
                let maxHeight = 0;
                const slides = container.querySelectorAll('.swiper-slide');

                // Find the tallest slide
                slides.forEach((slide) => {
                    const slideHeight = slide.offsetHeight;
                    if (slideHeight > maxHeight) {
                        maxHeight = slideHeight;
                    }
                });

                // Apply the tallest height to all slides
                slides.forEach((slide) => {
                    slide.style.height = `${maxHeight}px`;
                });

                // Update Swiper after setting the heights
                swiper.update();
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', () => {
                initializeSwiper();
            });
        });
    }
}

function testimonialImageSlider() {
    const testimonialImageSliders = document.querySelectorAll('.testimonial-image-slider');

    if (testimonialImageSliders.length > 0) {
        testimonialImageSliders.forEach((testimonialImageSlider) => {

            function initializeSwiper() {
                let swiper = new Swiper(testimonialImageSlider, {
                    modules: [ Navigation, Pagination ],
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next.image',
                        prevEl: '.swiper-button-prev.image',
                    },
                    pagination: {
                        el: ".testimonial-swiper-pagination",
                        type: "custom",
                        renderCustom: function (swiper, current, total) {
                            return `<span class="text-red">${current}</span> / ${total}`;
                        },
                    }, 
                    slidesPerView: 1,
                    spaceBetween: 40,
                    speed: 1000,
                    centeredSlides: true,
                    breakpoints: {
                        576: {
                            slidesPerView: 1.2,
                        },
                    },
                });

                // Set the height of all slides to the height of the tallest slide
                setEqualHeight(testimonialImageSlider, swiper);
            }

            function setEqualHeight(container, swiper) {
                let maxHeight = 0;
                const slides = container.querySelectorAll('.swiper-slide');

                // Find the tallest slide
                slides.forEach((slide) => {
                    const slideHeight = slide.offsetHeight;
                    if (slideHeight > maxHeight) {
                        maxHeight = slideHeight;
                    }
                });

                // Apply the tallest height to all slides
                slides.forEach((slide) => {
                    slide.style.height = `${maxHeight}px`;
                });

                // Update Swiper after setting the heights
                swiper.update();
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', () => {
                initializeSwiper();
            });
        });
    }
}

export { testimonialNoImageSlider, testimonialImageSlider };
